import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchQboStatusDownloadAPI } from '@services/WebApiService';
import { canShowPagination } from '@utilities';

const qboFetchStatusDownloadAsync = createAsyncThunk(
  'QboStatusDownload/fetchStatusDownload',
  async ({ pageLink, query, top, skip, statuses }, { getState }) => {
    const { accessToken } = getState().auth;
    const data = await fetchQboStatusDownloadAPI(accessToken, pageLink, {
      query,
      top,
      skip,
      statuses,
    });
    return data;
  }
);

const { pending, fulfilled, rejected } = qboFetchStatusDownloadAsync;

const qboFetchStatusDownloadExtraReducers = {
  [pending]: (state) => {
    state.fetchingQboStatusDownload = true;
  },
  [rejected]: (state) => {
    state.fetchingQboStatusDownload = false;
  },
  [fulfilled]: (state, action) => {
    state.fetchingQboStatusDownload = false;

    if (action.payload.error) {
      state.error = action.payload.error;
    } else if (action.payload.value) {
      const showPagination = canShowPagination(state.QboStatusDownload.showPagination, action);

      state.QboStatusDownload = {
        value: action.payload.value,
        nextLink: action.payload.nextLink,
        prevLink: action.payload.prevLink,
        showPagination,
      };
    }
  },
};

export { qboFetchStatusDownloadAsync, qboFetchStatusDownloadExtraReducers };
